import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AgendasService } from '@app/shared/services/agendas.service';
const PENDIENTES = 'pendientes';
const ENVIADOS = 'enviados';
@Component({
  selector: 'app-agendas-filter',
  templateUrl: './agendas-filter.component.html',
  styleUrls: ['./agendas-filter.component.scss']
})
export class AgendasFilterComponent implements OnInit {

  @Output() closeDialog = new EventEmitter<any>();
  @Output() filterAgendas = new EventEmitter<any>();
  @Output() seeClearFilter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public _display = false
  public _clear = false
  checkEnviados:boolean;

  constructor(private agendasService: AgendasService) {}

  get display() {
    return this._display;
  }

  @Input()
  set display(val) {
    this._display = val;
  }

  get clear() {
    return this._clear;
  }

  @Input()
  set clear(val) {
    this._clear = val;
    if (!this._display) this.clearFilterAgendas();
  }

  ngOnInit(): void {
  }

  onClickCloseModal() {
    this.display = !this.display;
  }

  close() {
   this.closeDialog.emit(false);
  }

  onChangeValue(event: any){
    let value = event.checked;
    this.checkEnviados = value ? true : false;
  }

  onFilterAgendas() {
    if (this.checkEnviados) {
      this.filterAgendas.emit(ENVIADOS);
      this.seeClearFilter.emit(true);
    }
  }

  clearFilterAgendas() {
    this.filterAgendas.emit(PENDIENTES);
    this.seeClearFilter.emit(false);
    this.close();
    this.checkEnviados=false;
  }
}
